// extracted by mini-css-extract-plugin
module.exports = {"animatedBorder":"MoreAbout_animatedBorder__5Lqcs","rotate":"MoreAbout_rotate__OwNvt","fadeOut":"MoreAbout_fadeOut__q1vmY"};